import RouteConstants from '@/features/router/RouteConstants';
import { SettingsIcon } from '@/lib';
import { ComponentProps, FC } from 'react';
import { BaseSidebarItem } from '../BaseSidebarItem';
import { NavSidebarItem } from '../NavSidebarItem/NavSidebarItem';

type SidebarSettingsItemProps = Pick<ComponentProps<typeof BaseSidebarItem>, 'classNames'> & {
  classNames?: {
    item?: string;
  };
};

export const SidebarSettingsItem: FC<SidebarSettingsItemProps> = (props) => {
  return <NavSidebarItem icon={SettingsIcon} title='ALL:setting_other' path={RouteConstants.settings} {...props} />;
};
